import { render } from "./DeadlineForm.vue?vue&type=template&id=8d56b186"
import script from "./DeadlineForm.vue?vue&type=script&lang=js"
export * from "./DeadlineForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__